import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import lottie from 'lottie-web';
import animationData from '../../assets/ThankYouHeart.json';

const TipHeartAnimation = ({ isAnimating, onComplete, 'data-testid': testId }) => {
  const containerRef = useRef(null);
  const onCompleteRef = useRef(onComplete);
  onCompleteRef.current = onComplete;

  useEffect(() => {
    if (!isAnimating || !containerRef.current) return;

    let cancelled = false;

    const anim = lottie.loadAnimation({
      container: containerRef.current,
      renderer: 'svg',
      loop: false,
      autoplay: true,
      animationData,
      rendererSettings: { preserveAspectRatio: 'xMidYMid meet' },
    });

    anim.addEventListener('complete', () => {
      if (!cancelled) onCompleteRef.current();
    });

    return () => {
      cancelled = true;
      anim.destroy();
    };
  }, [isAnimating]);

  return (
    <div
      ref={containerRef}
      data-testid={testId}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 95,
        pointerEvents: 'none',
        display: isAnimating ? 'block' : 'none',
      }}
    />
  );
};

TipHeartAnimation.propTypes = {
  isAnimating: PropTypes.bool,
  onComplete: PropTypes.func,
  'data-testid': PropTypes.string,
};

TipHeartAnimation.defaultProps = {
  isAnimating: false,
  onComplete: () => {},
  'data-testid': undefined,
};

export default TipHeartAnimation;
